export const LOCATION_TYPE = "LOCATION_TYPE";
export const ATTENDANCE_OFFICE_LIST = "ATTENDANCE_OFFICE_LIST";
export const ATTENDANCE_SITE_LIST = "ATTENDANCE_SITE_LIST";
